import { render } from "./ProfileSvg.vue?vue&type=template&id=9f5cf152&bindings={}"
import script from "./ProfileSvg.vue?vue&type=script&lang=ts"
export * from "./ProfileSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script